export default __webpack_public_path__ + "f9fa2d15762a829dc1c4caa909b7b47b.png";